import { Component, Input, EventEmitter } from '@angular/core';
import { FormControl } from '@angular/forms';
import { UtilityService } from 'services';

@Component({
  selector: 'app-textarea-field',
  templateUrl: './global-textarea.component.html'
})
export class GlobalTextareaComponent {

  @Input() label: string;
  @Input() maxlength: number;
  @Input() rows: number;
  @Input() hint?: string;
  @Input() placeholder?: string;
  @Input() control: FormControl;
  @Input() tooltip;
  @Input() charCount: number = null;
  @Input() maxWords: number;
  wordCount: number = 0;
  text: FormControl;

  constructor(private util: UtilityService) { }

  ngOnInit() {
    this.text = this.control;
    this.text.valueChanges.subscribe((text) => {
      if (text) {
        this.wordCount = text.trim().split(/\s+/).length;
        if (this.wordCount == this.maxWords) {
          this.maxlength = text.length;
        }
      } else {
        this.wordCount = 0;
      }
    });
  }

  isRequired() {
    return this.util.isRequired(this.control);
  }
}
